<ng-template #modal let-modal class="modal-dialog-centered backdropHigher">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title" id="topModalLabel">{{'MISC.FILES' | translate}}</h4>
            <button type="button" class="btn-close" tabindex="-1" aria-label="Close"
                (click)="modal.dismiss('Cross click'); closeModal.emit()">
            </button>
        </div>
        <div class="modal-body">
            <div class="row" id="modalFiles">
                <div class="col col-12 col-md-6 col-lg-5">
                    <form *ngIf="!onlyPreview" #fileUpload="ngForm">
                        <ngx-dropzone (change)="onSelect($event)">
                            <div class="dropzone">
                                <i class="mdi mdi-cloud-upload-outline"></i>
                                <ngx-dropzone-label class="drop-label">Drop your files here!</ngx-dropzone-label>
                            </div>
                        </ngx-dropzone>
                    </form>

                    <!-- Preview -->
                    <div class="dropzone-previews {{onlyPreview ? '' : 'mt-3'}}" id="file-previews">
                        <h5>{{'FILES.LIST' | translate}}</h5>

                        <!-- file preview template -->
                        <div *ngIf="files.length === 0">
                            <p>{{'FILES.NOFILES' | translate}}</p>
                        </div>
                        <div *ngIf="files.length > 0" class="file-list">
                            <div id="uploadPreviewTemplate" *ngFor="let f of files; let i=index">
                                <div class="card mt-1 mb-0 shadow-none border">
                                    <div class="row align-items-center" (click)="selectFile(f)"
                                        style="cursor: pointer;">
                                        <div class="col-auto">
                                            <img *ngIf="f.mimetype.includes('image')" class="avatar-sm rounded bg-light"
                                                [alt]="f.originalname" [src]="f.urlSanitize">
                                            <div *ngIf="!f.mimetype.includes('image')" class="icon-file rounded">
                                                <i [class]="f.fileIcon"></i>
                                            </div>
                                        </div>
                                        <div class="col ps-0">
                                            <div class="text-primary fw-bold">{{f.originalname}}</div>
                                            <span class="text-muted mb-0">{{f.fileSize}}</span>
                                        </div>
                                        <div class="col-auto">
                                            <!-- Button -->
                                            <a (click)="$event.stopPropagation()" [href]="f.url"
                                                class="btn btn-link text-muted">
                                                <i class="mdi mdi-download"></i>
                                            </a>
                                            <a *ngIf="!onlyPreview" class="btn btn-link text-muted"
                                                (click)="onRemove(i)">
                                                <i class="mdi mdi-delete"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end file preview template -->
                    </div>
                </div>
                <div class="col col-12 col-md-6 col-lg-7" id="previewFile">
                    <div class="preview-header" style="display: inline-flex;">
                        <h5>{{'FILES.PREVIEW' | translate}}</h5>
                        <a class="a-link" *ngIf="selectedFile" (click)="openTabPreview()">
                            <i class="mdi mdi-launch"></i>
                            {{'FILES.NEWTAB' | translate}}
                        </a>
                    </div>
                    <iframe *ngIf="selectedFile && !selectedFile.mimetype.includes('image')"
                        [src]="selectedFile.urlSanitize"></iframe>
                    <p-image *ngIf="selectedFile && selectedFile.mimetype.includes('image')" width="100%"
                        class="bg-light preview-image" [src]="selectedFile.urlSanitize"
                        [alt]="selectedFile.originalname" [preview]="true">
                    </p-image>
                </div>
            </div>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-center">
            <button class="btn btn-primary waves-effect waves-light btnSaveBottom btnSaveMinW2" (click)="save()">
                {{'MISC.SAVE'| translate}}
            </button>
        </div>

    </div>
</ng-template>